import { actionCreator, ActionReturnType, Loading, loadingNotStarted, loadingIsLoading, loadingFinished } from "@itk/typescript-utils";
import { Model_FaqCategoryGet, Shared_Languages } from "src/backend/openapi/v1";

export enum Action {
  GetFaqRequestByLanguageId = "@@ITK:SRC:PAGES:FAQ:FAQ-STORE.TS:ACTION:GETFAQREQUESTBYLANGUAGEID",
  GetFaqSuccessByLanguageId = "@@ITK:SRC:PAGES:FAQ:FAQ-STORE.TS:ACTION:GETFAQSUCCESSBYLANGUAGEID",

  Clear = "@@ITK:SRC:PAGES:FAQ:FAQ-STORE.TS:ACTION:CLEAR"
}

type FaqCategoryState = {
  faqCategory: Loading<Model_FaqCategoryGet[]>;
  loadedDataLanguageId: Shared_Languages | null;
};

const initialState: FaqCategoryState = {
  faqCategory: loadingNotStarted,
  loadedDataLanguageId: null
};

export const faqActions = {
  getFaqRequestByLanguageId: (languageId: Shared_Languages) => actionCreator(Action.GetFaqRequestByLanguageId, { languageId }),
  getFaqSuccessByLanguageId: (data: Model_FaqCategoryGet[], languageId: Shared_Languages) => actionCreator(Action.GetFaqSuccessByLanguageId, { data, languageId }),

  clear: () => actionCreator(Action.Clear)
};

export const faqReducer = (state = initialState, action: ActionReturnType<typeof faqActions>): FaqCategoryState => {
  switch (action.type) {
    case Action.GetFaqRequestByLanguageId:
      return { ...state, faqCategory: loadingIsLoading };
    case Action.GetFaqSuccessByLanguageId:
      return { ...state, faqCategory: loadingFinished(action.payload.data), loadedDataLanguageId: action.payload.languageId };

    case Action.Clear:
      return initialState;
    default:
      return state;
  }
};
